import { LaunchDarklyFlagStrategy } from '@nab/nab-x-sdk-browser';
import type { ServicesConfig } from '@nab/x-types';

/**
 * Build the flags services config from the shell config.
 *
 * LaunchDarklyFlagStrategy throws on a falsy clientId, so an unconfigured environment would stop
 * the SPA from starting. Flags are skipped instead, and the absence is logged so a misconfigured
 * config.json is visible rather than silently falling back to useFlag defaults.
 */
export default function getFlagsConfig(shellConfig: any): ServicesConfig {
    const clientId = String(shellConfig?.['launchDarkly']?.['clientId'] ?? '').trim();

    if (!clientId) {
        // eslint-disable-next-line no-console
        console.warn('LaunchDarkly clientId is not configured; starting without feature flags');
        return {};
    }

    return {
        flags: {
            // apiKey and initialData are unused by the client-side LaunchDarkly strategy, which
            // takes the clientId directly, but ServicesConfig declares both as required.
            strategy: new LaunchDarklyFlagStrategy(clientId),
            apiKey: '',
            initialData: undefined
        }
    };
}
